import { render, staticRenderFns } from "./largeVideo.vue?vue&type=template&id=4ad82793&scoped=true"
import script from "./largeVideo.vue?vue&type=script&lang=js"
export * from "./largeVideo.vue?vue&type=script&lang=js"
import style0 from "./largeVideo.vue?vue&type=style&index=0&id=4ad82793&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad82793",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad82793')) {
      api.createRecord('4ad82793', component.options)
    } else {
      api.reload('4ad82793', component.options)
    }
    module.hot.accept("./largeVideo.vue?vue&type=template&id=4ad82793&scoped=true", function () {
      api.rerender('4ad82793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeVideo.vue"
export default component.exports